// import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import {
  Navbar,
  NavbarBrand,
  NavItem,
  Container,
  NavLink
} from 'reactstrap';
import React, { Component } from 'react';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import { Link } from 'react-router-dom';
import c from '../../../constants/Colors';
import { AuthContext } from "../../../store/provider/AuthProvider";

export class NavMenuAuth extends Component {
  static displayName = NavMenuAuth.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.state = {
      collapsed: true,
    };
  }

  authHeader(isLoggedIn, hideNav) {
    console.log('hideNav', hideNav)
    // debugger;
    if (!isLoggedIn && !hideNav) {
      return (this.renderHeader(isLoggedIn));
    }
    return null;
  }

  renderHeader() {
    const auth = this.context;
    //   console.log(auth);
    return (
      <div>
        <Navbar className="navbar-expand-sm navbar_auth desktop">
          <Container>
            <NavbarBrand tag={Link} to="/">
              <img className='logo' src={require('../../../assets/img/isologo.png')} />
              <SvgAssets icon="curve-bottom" className='curve-bottom' fill="#fff" />
            </NavbarBrand>
            <ul className="navbar-nav ml-auto">
              <NavItem>
                <NavLink tag={Link} to={{ pathname: '/', state: { step: 1 }}} className="nav-link">
                  <SvgAssets icon="icon-user" fill={c.azulClaro} /> Iniciar sesión
                    </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} className="nav-link" to="/solicitar-acceso">
                  Solicitar Acceso
                    </NavLink>
              </NavItem>
            </ul>
          </Container>
        </Navbar>
      </div>
    )
  }

  render() {
    const { isLoggedIn, hideNav } = this.props;
    return (
      <header>
        {this.authHeader(isLoggedIn, hideNav)}
      </header>
    );
  }
}
